import { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { PlanDetailView } from "../VIEW/PlanDetailView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function PlanDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.PLANNER}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <PlanDetailView planId={id} uid={user.uid} email={user.email || ""} />;
}

export default PlanDetailPage;
